import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueLodash from 'vue-lodash';
import lodash from 'lodash'
import VueFlashMessage from 'vue-flash-message';
import * as filters from '../filters';
import 'vue-flash-message/dist/vue-flash-message.min.css';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { datadogRum } from '@datadog/browser-rum';
import setSentryContext from '../tracking/sentry/setSentryContext';

const datadogEnabled = (process.env.DATADOG_ENABLED === 'true');
const datadogClientToken = process.env.DATADOG_CLIENT_TOKEN;
const datadogApplicationId = process.env.DATADOG_APPLICATION_ID;
const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
const sentryEndpoint = process.env.SENTRY_ENDPOINT;

if (sentryEnabled) {
  const { environment, app_version, user_email } = analyticsDataLayer;
  const user_id = analyticsDataLayer.customerId; // account_id

  Sentry.init({
    dsn:          sentryEndpoint,
    release:      app_version,
    environment,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });

  window.Sentry = Sentry;
  setSentryContext();
}

if (datadogEnabled) {
  datadogRum.init({
    applicationId: datadogApplicationId,
    clientToken:   datadogClientToken,
    site: 'datadoghq.com',
    service: 'simplic_acq',
    sampleRate: 10,
  });
}

Vue.use(Vuelidate);
Vue.use(VueLodash, { lodash: lodash });

Vue.use(VueFlashMessage, {
  messageOptions: {
    callback: () => {
      // bypass auto scrolling.
      if (history && 'scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      document.documentElement.scrollTop = 0;
    },
  },
});
Vue.config.productionTip = false;


// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(filters)) {
  Vue.filter(key, value);
}
